import { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";
import { API } from "./SiteDataContext";

const AdminAuthContext = createContext();
const TOKEN_KEY = "slaly_admin_token";

export const AdminAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");

  const login = useCallback(async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setToken(data.token);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
  }, []);

  const authAxios = useCallback(
    () => axios.create({ baseURL: API, headers: { Authorization: `Bearer ${token}` } }),
    [token]
  );

  return (
    <AdminAuthContext.Provider value={{ token, isAuthed: !!token, login, logout, authAxios }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
